/////////////////////////////////////////////////////////////////
///Função para controlar a dialog
/////////////////////////////////////////////////////////////////
/*! medium-zoom 1.1.0 | MIT License | https://github.com/francoischalifour/medium-zoom */ var $4ffa2ba0c2b40bcc$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $4ffa2ba0c2b40bcc$var$isSupported = function isSupported(node) {
    return node.tagName === 'IMG';
};
/* eslint-disable-next-line no-prototype-builtins */ var $4ffa2ba0c2b40bcc$var$isNodeList = function isNodeList(selector) {
    return NodeList.prototype.isPrototypeOf(selector);
};
var $4ffa2ba0c2b40bcc$var$isNode = function isNode(selector) {
    return selector && selector.nodeType === 1;
};
var $4ffa2ba0c2b40bcc$var$isSvg = function isSvg(image) {
    var source = image.currentSrc || image.src;
    return source.substr(-4).toLowerCase() === '.svg';
};
var $4ffa2ba0c2b40bcc$var$getImagesFromSelector = function getImagesFromSelector(selector) {
    try {
        if (Array.isArray(selector)) return selector.filter($4ffa2ba0c2b40bcc$var$isSupported);
        if ($4ffa2ba0c2b40bcc$var$isNodeList(selector)) // Do not use spread operator or Array.from() for IE support
        return [].slice.call(selector).filter($4ffa2ba0c2b40bcc$var$isSupported);
        if ($4ffa2ba0c2b40bcc$var$isNode(selector)) return [
            selector
        ].filter($4ffa2ba0c2b40bcc$var$isSupported);
        if (typeof selector === 'string') // Do not use spread operator or Array.from() for IE support
        return [].slice.call(document.querySelectorAll(selector)).filter($4ffa2ba0c2b40bcc$var$isSupported);
        return [];
    } catch (err) {
        throw new TypeError("The provided selector is invalid.\nExpects a CSS selector, a Node element, a NodeList or an array.\nSee: https://github.com/francoischalifour/medium-zoom");
    }
};
var $4ffa2ba0c2b40bcc$var$createOverlay = function createOverlay(background) {
    var overlay = document.createElement('div');
    overlay.classList.add('medium-zoom-overlay');
    overlay.style.background = background;
    return overlay;
};
var $4ffa2ba0c2b40bcc$var$cloneTarget = function cloneTarget(template) {
    var _template$getBounding = template.getBoundingClientRect(), top = _template$getBounding.top, left = _template$getBounding.left, width = _template$getBounding.width, height = _template$getBounding.height;
    var clone = template.cloneNode();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    clone.removeAttribute('id');
    clone.style.position = 'absolute';
    clone.style.top = top + scrollTop + 'px';
    clone.style.left = left + scrollLeft + 'px';
    clone.style.width = width + 'px';
    clone.style.height = height + 'px';
    clone.style.transform = '';
    return clone;
};
var $4ffa2ba0c2b40bcc$var$createCustomEvent = function createCustomEvent(type, params) {
    var eventParams = $4ffa2ba0c2b40bcc$var$_extends({
        bubbles: false,
        cancelable: false,
        detail: undefined
    }, params);
    if (typeof window.CustomEvent === 'function') return new CustomEvent(type, eventParams);
    var customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(type, eventParams.bubbles, eventParams.cancelable, eventParams.detail);
    return customEvent;
};
var $4ffa2ba0c2b40bcc$var$mediumZoom = function mediumZoom(selector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    /**
   * Ensure the compatibility with IE11 if no Promise polyfill are used.
   */ var Promise = window.Promise || function Promise(fn) {
        function noop() {}
        fn(noop, noop);
    };
    var _handleClick = function _handleClick(event) {
        var target = event.target;
        if (target === overlay) {
            close();
            return;
        }
        if (images.indexOf(target) === -1) return;
        toggle({
            target: target
        });
    };
    var _handleScroll = function _handleScroll() {
        if (isAnimating || !active.original) return;
        var currentScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (Math.abs(scrollTop - currentScroll) > zoomOptions.scrollOffset) setTimeout(close, 150);
    };
    var _handleKeyUp = function _handleKeyUp(event) {
        var key = event.key || event.keyCode;
        // Close if escape key is pressed
        if (key === 'Escape' || key === 'Esc' || key === 27) close();
    };
    var update = function update() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var newOptions = options;
        if (options.background) overlay.style.background = options.background;
        if (options.container && options.container instanceof Object) newOptions.container = $4ffa2ba0c2b40bcc$var$_extends({}, zoomOptions.container, options.container);
        if (options.template) {
            var template = $4ffa2ba0c2b40bcc$var$isNode(options.template) ? options.template : document.querySelector(options.template);
            newOptions.template = template;
        }
        zoomOptions = $4ffa2ba0c2b40bcc$var$_extends({}, zoomOptions, newOptions);
        images.forEach(function(image) {
            image.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent('medium-zoom:update', {
                detail: {
                    zoom: zoom
                }
            }));
        });
        return zoom;
    };
    var clone = function clone() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return mediumZoom($4ffa2ba0c2b40bcc$var$_extends({}, zoomOptions, options));
    };
    var attach = function attach() {
        for(var _len = arguments.length, selectors = Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
        var newImages = selectors.reduce(function(imagesAccumulator, currentSelector) {
            return [].concat(imagesAccumulator, $4ffa2ba0c2b40bcc$var$getImagesFromSelector(currentSelector));
        }, []);
        newImages.filter(function(newImage) {
            return images.indexOf(newImage) === -1;
        }).forEach(function(newImage) {
            images.push(newImage);
            newImage.classList.add('medium-zoom-image');
        });
        eventListeners.forEach(function(_ref) {
            var type = _ref.type, listener = _ref.listener, options = _ref.options;
            newImages.forEach(function(image) {
                image.addEventListener(type, listener, options);
            });
        });
        return zoom;
    };
    var detach = function detach() {
        for(var _len2 = arguments.length, selectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)selectors[_key2] = arguments[_key2];
        if (active.zoomed) close();
        var imagesToDetach = selectors.length > 0 ? selectors.reduce(function(imagesAccumulator, currentSelector) {
            return [].concat(imagesAccumulator, $4ffa2ba0c2b40bcc$var$getImagesFromSelector(currentSelector));
        }, []) : images;
        imagesToDetach.forEach(function(image) {
            image.classList.remove('medium-zoom-image');
            image.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent('medium-zoom:detach', {
                detail: {
                    zoom: zoom
                }
            }));
        });
        images = images.filter(function(image) {
            return imagesToDetach.indexOf(image) === -1;
        });
        return zoom;
    };
    var on = function on(type, listener) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        images.forEach(function(image) {
            image.addEventListener('medium-zoom:' + type, listener, options);
        });
        eventListeners.push({
            type: 'medium-zoom:' + type,
            listener: listener,
            options: options
        });
        return zoom;
    };
    var off = function off(type, listener) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        images.forEach(function(image) {
            image.removeEventListener('medium-zoom:' + type, listener, options);
        });
        eventListeners = eventListeners.filter(function(eventListener) {
            return !(eventListener.type === 'medium-zoom:' + type && eventListener.listener.toString() === listener.toString());
        });
        return zoom;
    };
    var open = function open() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, target = _ref2.target;
        var _animate = function _animate() {
            var container = {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight,
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            var viewportWidth = void 0;
            var viewportHeight = void 0;
            if (zoomOptions.container) {
                if (zoomOptions.container instanceof Object) {
                    // The container is given as an object with properties like width, height, left, top
                    container = $4ffa2ba0c2b40bcc$var$_extends({}, container, zoomOptions.container);
                    // We need to adjust custom options like container.right or container.bottom
                    viewportWidth = container.width - container.left - container.right - zoomOptions.margin * 2;
                    viewportHeight = container.height - container.top - container.bottom - zoomOptions.margin * 2;
                } else {
                    // The container is given as an element
                    var zoomContainer = $4ffa2ba0c2b40bcc$var$isNode(zoomOptions.container) ? zoomOptions.container : document.querySelector(zoomOptions.container);
                    var _zoomContainer$getBou = zoomContainer.getBoundingClientRect(), _width = _zoomContainer$getBou.width, _height = _zoomContainer$getBou.height, _left = _zoomContainer$getBou.left, _top = _zoomContainer$getBou.top;
                    container = $4ffa2ba0c2b40bcc$var$_extends({}, container, {
                        width: _width,
                        height: _height,
                        left: _left,
                        top: _top
                    });
                }
            }
            viewportWidth = viewportWidth || container.width - zoomOptions.margin * 2;
            viewportHeight = viewportHeight || container.height - zoomOptions.margin * 2;
            var zoomTarget = active.zoomedHd || active.original;
            var naturalWidth = $4ffa2ba0c2b40bcc$var$isSvg(zoomTarget) ? viewportWidth : zoomTarget.naturalWidth || viewportWidth;
            var naturalHeight = $4ffa2ba0c2b40bcc$var$isSvg(zoomTarget) ? viewportHeight : zoomTarget.naturalHeight || viewportHeight;
            var _zoomTarget$getBoundi = zoomTarget.getBoundingClientRect(), top = _zoomTarget$getBoundi.top, left = _zoomTarget$getBoundi.left, width = _zoomTarget$getBoundi.width, height = _zoomTarget$getBoundi.height;
            var scaleX = Math.min(Math.max(width, naturalWidth), viewportWidth) / width;
            var scaleY = Math.min(Math.max(height, naturalHeight), viewportHeight) / height;
            var scale = Math.min(scaleX, scaleY);
            var translateX = (-left + (viewportWidth - width) / 2 + zoomOptions.margin + container.left) / scale;
            var translateY = (-top + (viewportHeight - height) / 2 + zoomOptions.margin + container.top) / scale;
            var transform = 'scale(' + scale + ') translate3d(' + translateX + 'px, ' + translateY + 'px, 0)';
            active.zoomed.style.transform = transform;
            if (active.zoomedHd) active.zoomedHd.style.transform = transform;
        };
        return new Promise(function(resolve) {
            if (target && images.indexOf(target) === -1) {
                resolve(zoom);
                return;
            }
            var _handleOpenEnd = function _handleOpenEnd() {
                isAnimating = false;
                active.zoomed.removeEventListener('transitionend', _handleOpenEnd);
                active.original.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent('medium-zoom:opened', {
                    detail: {
                        zoom: zoom
                    }
                }));
                resolve(zoom);
            };
            if (active.zoomed) {
                resolve(zoom);
                return;
            }
            if (target) // The zoom was triggered manually via a click
            active.original = target;
            else if (images.length > 0) {
                var _images = images;
                active.original = _images[0];
            } else {
                resolve(zoom);
                return;
            }
            active.original.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent('medium-zoom:open', {
                detail: {
                    zoom: zoom
                }
            }));
            scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            isAnimating = true;
            active.zoomed = $4ffa2ba0c2b40bcc$var$cloneTarget(active.original);
            document.body.appendChild(overlay);
            if (zoomOptions.template) {
                var template = $4ffa2ba0c2b40bcc$var$isNode(zoomOptions.template) ? zoomOptions.template : document.querySelector(zoomOptions.template);
                active.template = document.createElement('div');
                active.template.appendChild(template.content.cloneNode(true));
                document.body.appendChild(active.template);
            }
            // If the selected <img> tag is inside a <picture> tag, set the
            // currently-applied source as the cloned `src=` attribute.
            // (as these might differ, or src= might be unset in some cases)
            if (active.original.parentElement && active.original.parentElement.tagName === 'PICTURE' && active.original.currentSrc) active.zoomed.src = active.original.currentSrc;
            document.body.appendChild(active.zoomed);
            window.requestAnimationFrame(function() {
                document.body.classList.add('medium-zoom--opened');
            });
            active.original.classList.add('medium-zoom-image--hidden');
            active.zoomed.classList.add('medium-zoom-image--opened');
            active.zoomed.addEventListener('click', close);
            active.zoomed.addEventListener('transitionend', _handleOpenEnd);
            if (active.original.getAttribute('data-zoom-src')) {
                active.zoomedHd = active.zoomed.cloneNode();
                // Reset the `scrset` property or the HD image won't load.
                active.zoomedHd.removeAttribute('srcset');
                active.zoomedHd.removeAttribute('sizes');
                // Remove loading attribute so the browser can load the image normally
                active.zoomedHd.removeAttribute('loading');
                active.zoomedHd.src = active.zoomed.getAttribute('data-zoom-src');
                active.zoomedHd.onerror = function() {
                    clearInterval(getZoomTargetSize);
                    console.warn('Unable to reach the zoom image target ' + active.zoomedHd.src);
                    active.zoomedHd = null;
                    _animate();
                };
                // We need to access the natural size of the full HD
                // target as fast as possible to compute the animation.
                var getZoomTargetSize = setInterval(function() {
                    if (active.zoomedHd.complete) {
                        clearInterval(getZoomTargetSize);
                        active.zoomedHd.classList.add('medium-zoom-image--opened');
                        active.zoomedHd.addEventListener('click', close);
                        document.body.appendChild(active.zoomedHd);
                        _animate();
                    }
                }, 10);
            } else if (active.original.hasAttribute('srcset')) {
                // If an image has a `srcset` attribuet, we don't know the dimensions of the
                // zoomed (HD) image (like when `data-zoom-src` is specified).
                // Therefore the approach is quite similar.
                active.zoomedHd = active.zoomed.cloneNode();
                // Resetting the sizes attribute tells the browser to load the
                // image best fitting the current viewport size, respecting the `srcset`.
                active.zoomedHd.removeAttribute('sizes');
                // In Firefox, the `loading` attribute needs to be set to `eager` (default
                // value) for the load event to be fired.
                active.zoomedHd.removeAttribute('loading');
                // Wait for the load event of the hd image. This will fire if the image
                // is already cached.
                var loadEventListener = active.zoomedHd.addEventListener('load', function() {
                    active.zoomedHd.removeEventListener('load', loadEventListener);
                    active.zoomedHd.classList.add('medium-zoom-image--opened');
                    active.zoomedHd.addEventListener('click', close);
                    document.body.appendChild(active.zoomedHd);
                    _animate();
                });
            } else _animate();
        });
    };
    var close = function close() {
        return new Promise(function(resolve) {
            if (isAnimating || !active.original) {
                resolve(zoom);
                return;
            }
            var _handleCloseEnd = function _handleCloseEnd() {
                active.original.classList.remove('medium-zoom-image--hidden');
                document.body.removeChild(active.zoomed);
                if (active.zoomedHd) document.body.removeChild(active.zoomedHd);
                document.body.removeChild(overlay);
                active.zoomed.classList.remove('medium-zoom-image--opened');
                if (active.template) document.body.removeChild(active.template);
                isAnimating = false;
                active.zoomed.removeEventListener('transitionend', _handleCloseEnd);
                active.original.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent('medium-zoom:closed', {
                    detail: {
                        zoom: zoom
                    }
                }));
                active.original = null;
                active.zoomed = null;
                active.zoomedHd = null;
                active.template = null;
                resolve(zoom);
            };
            isAnimating = true;
            document.body.classList.remove('medium-zoom--opened');
            active.zoomed.style.transform = '';
            if (active.zoomedHd) active.zoomedHd.style.transform = '';
            // Fade out the template so it's not too abrupt
            if (active.template) {
                active.template.style.transition = 'opacity 150ms';
                active.template.style.opacity = 0;
            }
            active.original.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent('medium-zoom:close', {
                detail: {
                    zoom: zoom
                }
            }));
            active.zoomed.addEventListener('transitionend', _handleCloseEnd);
        });
    };
    var toggle = function toggle() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, target = _ref3.target;
        if (active.original) return close();
        return open({
            target: target
        });
    };
    var getOptions = function getOptions() {
        return zoomOptions;
    };
    var getImages = function getImages() {
        return images;
    };
    var getZoomedImage = function getZoomedImage() {
        return active.original;
    };
    var images = [];
    var eventListeners = [];
    var isAnimating = false;
    var scrollTop = 0;
    var zoomOptions = options;
    var active = {
        original: null,
        zoomed: null,
        zoomedHd: null,
        template: null
    };
    if (Object.prototype.toString.call(selector) === '[object Object]') zoomOptions = selector;
    else if (selector || typeof selector === 'string' // to process empty string as a selector
    ) attach(selector);
    // Apply the default option values
    zoomOptions = $4ffa2ba0c2b40bcc$var$_extends({
        margin: 0,
        background: '#fff',
        scrollOffset: 40,
        container: null,
        template: null
    }, zoomOptions);
    var overlay = $4ffa2ba0c2b40bcc$var$createOverlay(zoomOptions.background);
    document.addEventListener('click', _handleClick);
    document.addEventListener('keyup', _handleKeyUp);
    document.addEventListener('scroll', _handleScroll);
    window.addEventListener('resize', close);
    var zoom = {
        open: open,
        close: close,
        toggle: toggle,
        update: update,
        clone: clone,
        attach: attach,
        detach: detach,
        on: on,
        off: off,
        getOptions: getOptions,
        getImages: getImages,
        getZoomedImage: getZoomedImage
    };
    return zoom;
};
function $4ffa2ba0c2b40bcc$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $4ffa2ba0c2b40bcc$var$css = ".medium-zoom-overlay{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .3s;will-change:opacity}.medium-zoom--opened .medium-zoom-overlay{cursor:pointer;cursor:zoom-out;opacity:1}.medium-zoom-image{cursor:pointer;cursor:zoom-in;transition:transform .3s cubic-bezier(.2,0,.2,1)!important}.medium-zoom-image--hidden{visibility:hidden}.medium-zoom-image--opened{position:relative;cursor:pointer;cursor:zoom-out;will-change:transform}";
$4ffa2ba0c2b40bcc$var$styleInject($4ffa2ba0c2b40bcc$var$css);
var $4ffa2ba0c2b40bcc$export$2e2bcd8739ae039 = $4ffa2ba0c2b40bcc$var$mediumZoom;


/**
 * Password Authentication Module
 * 
 * Provides utilities for password hashing, validation, and session management.
 */ /**
 * Password Configuration
 * 
 * This file stores password hashes and protected page mappings.
 * 
 * To generate a new password hash, run this in the browser console:
 * 
 * async function generateHash(password) {
 *   const encoder = new TextEncoder();
 *   const data = encoder.encode(password);
 *   const hashBuffer = await crypto.subtle.digest('SHA-256', data);
 *   const hashArray = Array.from(new Uint8Array(hashBuffer));
 *   return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
 * }
 * 
 * Then call: await generateHash('your-password')
 */ // Password hashes (SHA-256)
// Default password for demo: "demo123"
const $1b59a1188f654ec4$export$3cf2af023afdc4d9 = {
    'case-journal-finder': {
        hash: 'e4e2ff1a6fc2a6ce836b66c424aa2bdd4803d5b92d9750b0db4df4b1d1a8a597',
        redirectUrl: '/scaling-a-journal-matching-platform-to-1m-sessions-with-8-6-percent-conversion'
    },
    'case-subject-pages': {
        hash: 'e4e2ff1a6fc2a6ce836b66c424aa2bdd4803d5b92d9750b0db4df4b1d1a8a597',
        redirectUrl: '/turning-organic-traffic-into-250k-readers-with-scalable-landing-pages'
    }
};
const $1b59a1188f654ec4$export$a17ddac75cff4cbf = 'rc_auth_tokens';
const $1b59a1188f654ec4$export$aed1a45ba98d4cca = 'cases';
const $1b59a1188f654ec4$export$97017fb0dd41ee56 = 'rc_recruiter_access';


async function $2d55885df2a8a6bb$export$708be5cd94908894(password) {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
}
async function $2d55885df2a8a6bb$export$4d2a7159fda5dc93(contentId, password) {
    const config = (0, $1b59a1188f654ec4$export$3cf2af023afdc4d9)[contentId];
    if (!config) {
        console.error(`No password configuration found for content ID: ${contentId}`);
        return false;
    }
    const hash = await $2d55885df2a8a6bb$export$708be5cd94908894(password);
    return hash === config.hash;
}
function $2d55885df2a8a6bb$export$894225851aaae84a(contentId) {
    const tokens = $2d55885df2a8a6bb$var$getAuthTokens();
    tokens[contentId] = Date.now();
    sessionStorage.setItem((0, $1b59a1188f654ec4$export$a17ddac75cff4cbf), JSON.stringify(tokens));
}
function $2d55885df2a8a6bb$export$9bc230535f044cf5() {
    try {
        const url = new URL(window.location.href);
        const refParam = url.searchParams.get('ref');
        if (refParam && refParam.toLowerCase() === (0, $1b59a1188f654ec4$export$aed1a45ba98d4cca).toLowerCase()) {
            localStorage.setItem((0, $1b59a1188f654ec4$export$97017fb0dd41ee56), JSON.stringify({
                grantedAt: Date.now()
            }));
            // Push tracking event to dataLayer BEFORE cleaning the URL.
            // GTM processes all queued dataLayer entries when it loads,
            // so this works even if gtm.js hasn't finished downloading yet.
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'access_recruiter_token',
                event_category: 'auth',
                event_label: 'ref_parameter',
                page_location: window.location.href // captures full URL with ?ref=cases
            });
            // Clean ?ref= parameter from the URL without reloading
            url.searchParams.delete('ref');
            const searchStr = url.searchParams.toString();
            const cleanUrl = url.pathname + (searchStr ? `?${searchStr}` : '') + url.hash;
            window.history.replaceState(null, '', cleanUrl);
            return true;
        }
    } catch (error) {
        console.error('Error checking recruiter token:', error);
    }
    return false;
}
function $2d55885df2a8a6bb$export$421b07af08809ead() {
    try {
        return !!localStorage.getItem((0, $1b59a1188f654ec4$export$97017fb0dd41ee56));
    } catch (error) {
        return false;
    }
}
function $2d55885df2a8a6bb$export$83d11f23a23d4a7c(contentId) {
    // Recruiter token grants session-wide access to all protected content
    if ($2d55885df2a8a6bb$export$421b07af08809ead()) return true;
    const tokens = $2d55885df2a8a6bb$var$getAuthTokens();
    return !!tokens[contentId];
}
/**
 * Get all authentication tokens from session storage
 * @returns {Object} Object containing all auth tokens
 */ function $2d55885df2a8a6bb$var$getAuthTokens() {
    const stored = sessionStorage.getItem((0, $1b59a1188f654ec4$export$a17ddac75cff4cbf));
    return stored ? JSON.parse(stored) : {};
}
function $2d55885df2a8a6bb$export$ecb24604bffa7e6c(contentId = null) {
    if (contentId) {
        const tokens = $2d55885df2a8a6bb$var$getAuthTokens();
        delete tokens[contentId];
        sessionStorage.setItem((0, $1b59a1188f654ec4$export$a17ddac75cff4cbf), JSON.stringify(tokens));
    } else {
        sessionStorage.removeItem((0, $1b59a1188f654ec4$export$a17ddac75cff4cbf));
        localStorage.removeItem((0, $1b59a1188f654ec4$export$97017fb0dd41ee56));
    }
}
function $2d55885df2a8a6bb$export$93832c3affb240d3(contentId) {
    const config = (0, $1b59a1188f654ec4$export$3cf2af023afdc4d9)[contentId];
    return config ? config.redirectUrl : null;
}


const $00c5cb1594812d6b$var$modal = document.querySelector('.dialog-show-email');
const $00c5cb1594812d6b$var$openModal = document.querySelectorAll('.btn-show-email'); // Seleciona todos os botões que abrem a modal
const $00c5cb1594812d6b$var$closeModal = document.querySelector('.btn-close-email');
const $00c5cb1594812d6b$var$body = document.body;
// Alerta: página real ainda com "noindex" copiado do article-template
const $00c5cb1594812d6b$var$robotsMeta = document.querySelector('meta[name="robots"]');
if ($00c5cb1594812d6b$var$robotsMeta && /noindex/i.test($00c5cb1594812d6b$var$robotsMeta.content) && !/article-template|design-system|buttons/.test(window.location.pathname)) console.warn('[SEO] This page has <meta name="robots" content="noindex">, so Google will NOT index it. If this is a real article, replace it with: <meta name="robots" content="index, follow, max-image-preview:large" />');
// Função para abrir a dialog e adicionar um estado ao histórico
function $00c5cb1594812d6b$var$openDialog() {
    $00c5cb1594812d6b$var$body.classList.add('body-fixed'); // Add class to keep body fixed
    $00c5cb1594812d6b$var$modal.showModal();
    $00c5cb1594812d6b$var$modal.classList.remove('fade-out');
    // Adiciona um estado ao histórico quando a dialog é aberta
    history.pushState({
        page: 'my-email'
    }, 'my-email', '#my-email');
}
// Função para fechar a dialog e manipular o histórico
function $00c5cb1594812d6b$var$closeDialog() {
    $00c5cb1594812d6b$var$modal.classList.add('fade-out');
    setTimeout(()=>{
        $00c5cb1594812d6b$var$modal.close();
        $00c5cb1594812d6b$var$body.classList.remove('body-fixed'); // Remove the class
        // Remove the hash from the URL
        history.replaceState(null, '', window.location.pathname);
    }, 450);
}
// Adiciona evento de clique para todos os botões que abrem a modal
$00c5cb1594812d6b$var$openModal.forEach((button)=>{
    button.addEventListener("click", $00c5cb1594812d6b$var$openDialog);
});
// Adiciona evento de clique para o botão que fecha a modal
$00c5cb1594812d6b$var$closeModal.addEventListener("click", $00c5cb1594812d6b$var$closeDialog);
// Evento para fechar a dialog com a tecla ESC
// Evento para fechar a dialog com a tecla ESC
$00c5cb1594812d6b$var$modal.addEventListener('cancel', (event)=>{
    event.preventDefault();
    $00c5cb1594812d6b$var$closeDialog();
});
// Detecta quando o usuário clica em 'voltar' ou 'avançar' no navegador
window.addEventListener('popstate', (event)=>{
    // Verifica se o estado do histórico corresponde à abertura da modal
    if (event.state && event.state.page === 'my-email') $00c5cb1594812d6b$var$openDialog();
    else if ($00c5cb1594812d6b$var$modal.hasAttribute('open')) $00c5cb1594812d6b$var$closeDialog();
});
// Verifica se a URL contém o hash '#my-email' quando a página é carregada
document.addEventListener('DOMContentLoaded', (event)=>{
    if (window.location.hash === '#my-email') $00c5cb1594812d6b$var$openDialog();
});
// Check for recruiter access token on any page
(0, $2d55885df2a8a6bb$export$9bc230535f044cf5)();
const $00c5cb1594812d6b$var$passwordModal = document.querySelector('.dialog-show-password');
const $00c5cb1594812d6b$var$openPasswordModal = document.querySelectorAll('.btn-show-password');
const $00c5cb1594812d6b$var$closePasswordModal = $00c5cb1594812d6b$var$passwordModal?.querySelector('.btn-close-email');
// Paywall mode: protected case pages declare <body data-protected-content="<contentId>">.
// The full case is in the HTML (indexable by Google); visitors without access see the
// password dialog on top of the page instead of being redirected to the homepage.
const $00c5cb1594812d6b$var$protectedContentId = document.body.dataset.protectedContent || null;
// Alerta: página protegida sem a password dialog incluída
if ($00c5cb1594812d6b$var$protectedContentId && !$00c5cb1594812d6b$var$passwordModal) console.error(`[password-dialog] Protected page "${$00c5cb1594812d6b$var$protectedContentId}" is missing ` + `<include src="components/password-dialog.html"></include>. The case will stay hidden.`);
// Alerta: botões de senha existem mas a dialog não foi incluída na página
if (!$00c5cb1594812d6b$var$passwordModal && $00c5cb1594812d6b$var$openPasswordModal.length > 0) console.error(`[password-dialog] Missing <include src="components/password-dialog.html"></include> on this page. ` + `${$00c5cb1594812d6b$var$openPasswordModal.length} .btn-show-password button(s) found but will not work. See AGENTS.md Gotcha #12.`);
if ($00c5cb1594812d6b$var$passwordModal) {
    const passwordInput = $00c5cb1594812d6b$var$passwordModal.querySelector('input[type="password"]');
    const submitButton = $00c5cb1594812d6b$var$passwordModal.querySelector('.btn-submit');
    const errorMessage = $00c5cb1594812d6b$var$passwordModal.querySelector('.error-message');
    // Store current content ID
    let currentContentId = null;
    // Store original button content for restoring after BFCache
    let originalButtonContent = submitButton ? submitButton.innerHTML : '';
    // Função para abrir a password dialog
    function openPasswordDialog(skipAnimation = false) {
        $00c5cb1594812d6b$var$body.classList.add('body-fixed');
        // Track password dialog view
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'view_password_dialog',
            event_category: 'auth',
            event_label: currentContentId || 'unknown',
            page_location: window.location.href
        });
        // Add no-animation class to skip fade-in when opening from redirect
        if (skipAnimation) $00c5cb1594812d6b$var$passwordModal.classList.add('no-animation');
        else $00c5cb1594812d6b$var$passwordModal.classList.remove('no-animation');
        $00c5cb1594812d6b$var$passwordModal.showModal();
        // Only remove fade-out class if not skipping animation
        // When redirected from protected page, we want instant display
        if (!skipAnimation) $00c5cb1594812d6b$var$passwordModal.classList.remove('fade-out');
        // Clear previous input and errors
        if (passwordInput) {
            passwordInput.value = '';
            // passwordInput.focus(); // Removed to respect autofocus on close button
            // Detect keyboard open via visualViewport height reduction and toggle a class
            // so CSS can adapt the layout (e.g. reduce .dialog-heading margin-top on mobile).
            //
            // Reference notes:
            //   - screen.height: NOT used — on Chrome/iOS it always reports portrait height,
            //     causing false positives when the dialog is open in landscape.
            //   - window.innerHeight: NOT used — Firefox shrinks it when the keyboard opens,
            //     making the comparison always false on Firefox.
            //   - Solution: capture visualViewport.height at dialog open time as the stable
            //     reference, and update it whenever height increases (orientation change,
            //     browser chrome resizing). This works correctly in all orientations/browsers.
            if (window.visualViewport) {
                let referenceHeight = window.visualViewport.height;
                const onViewportResize = ()=>{
                    const currentHeight = window.visualViewport.height;
                    // Height grew → keyboard closed, or orientation changed to a taller state.
                    // Update reference so future comparisons stay accurate.
                    if (currentHeight > referenceHeight) referenceHeight = currentHeight;
                    const keyboardOpen = currentHeight < referenceHeight * 0.75;
                    $00c5cb1594812d6b$var$passwordModal.classList.toggle('keyboard-open', keyboardOpen);
                    // Firefox scrolls the window when an input is focused, even inside a
                    // position:fixed dialog. Reset scroll position to neutralise that shift.
                    if (keyboardOpen) window.scrollTo({
                        top: 0,
                        behavior: 'instant'
                    });
                };
                window.visualViewport.addEventListener('resize', onViewportResize);
                // Clean up when the dialog is closed so the listener doesn't linger.
                $00c5cb1594812d6b$var$passwordModal.addEventListener('close', ()=>{
                    window.visualViewport.removeEventListener('resize', onViewportResize);
                    $00c5cb1594812d6b$var$passwordModal.classList.remove('keyboard-open');
                }, {
                    once: true
                });
            }
        }
        if (errorMessage) errorMessage.style.display = 'none';
        // On paywalled pages the dialog is the page's initial state, so it must not add a
        // history entry (otherwise "back" would only reopen the dialog).
        if (!isPaywallDialog()) history.pushState({
            page: 'password-protected',
            contentId: currentContentId
        }, 'password-protected', `#password-protected${currentContentId ? `?content=${currentContentId}` : ''}`);
    }
    // True when the dialog is guarding the case on the current page (paywall mode)
    function isPaywallDialog() {
        return !!$00c5cb1594812d6b$var$protectedContentId && currentContentId === $00c5cb1594812d6b$var$protectedContentId && !(0, $2d55885df2a8a6bb$export$83d11f23a23d4a7c)($00c5cb1594812d6b$var$protectedContentId);
    }
    // Paywall: "Back to website" leaves the case without revealing it.
    // Came from another page of this site → go back to it. Otherwise (Google, LinkedIn,
    // bookmark, new tab) → homepage, so the visitor stays on the site.
    function leavePaywalledPage() {
        let cameFromThisSite = false;
        try {
            const ref = document.referrer ? new URL(document.referrer) : null;
            cameFromThisSite = !!ref && ref.origin === window.location.origin && ref.pathname !== window.location.pathname;
        } catch (error) {
            cameFromThisSite = false;
        }
        // Fade out first (same timing as closePasswordDialog), then navigate
        $00c5cb1594812d6b$var$passwordModal.classList.add('fade-out');
        setTimeout(()=>{
            if (cameFromThisSite && window.history.length > 1) window.history.back();
            else window.location.href = '/';
        }, 450);
    }
    // Paywall: reveal the case in place after a valid password
    function unlockPaywalledPage() {
        document.documentElement.classList.remove('is-locked');
        $00c5cb1594812d6b$var$passwordModal.classList.add('fade-out');
        setTimeout(()=>{
            $00c5cb1594812d6b$var$passwordModal.close();
            $00c5cb1594812d6b$var$body.classList.remove('body-fixed');
        }, 450);
    }
    // Função para fechar a password dialog
    function closePasswordDialog() {
        if (isPaywallDialog()) {
            leavePaywalledPage();
            return;
        }
        $00c5cb1594812d6b$var$passwordModal.classList.add('fade-out');
        setTimeout(()=>{
            $00c5cb1594812d6b$var$passwordModal.close();
            $00c5cb1594812d6b$var$body.classList.remove('body-fixed');
            history.replaceState(null, '', window.location.pathname);
        }, 450);
    }
    // Show error message
    function showError(message) {
        if (errorMessage) {
            errorMessage.textContent = message;
            errorMessage.style.display = 'block';
            setTimeout(()=>{
                errorMessage.style.display = 'none';
            }, 3000);
        }
    }
    // Handle password submission
    async function handlePasswordSubmit() {
        const password = passwordInput?.value.trim();
        if (!password) {
            showError('Please enter a password');
            return;
        }
        if (!currentContentId) {
            showError('Content ID not found');
            console.error('No content ID set for password dialog');
            return;
        }
        // Show loading state with spinner
        originalButtonContent = submitButton.innerHTML;
        submitButton.disabled = true;
        submitButton.innerHTML = '<div class="btn-spinner"></div>';
        try {
            // Validate password
            const isValid = await (0, $2d55885df2a8a6bb$export$4d2a7159fda5dc93)(currentContentId, password);
            if (isValid) {
                // Paywall: we're already on the case page, so unlock it in place
                if ($00c5cb1594812d6b$var$protectedContentId && currentContentId === $00c5cb1594812d6b$var$protectedContentId) {
                    (0, $2d55885df2a8a6bb$export$894225851aaae84a)(currentContentId);
                    submitButton.disabled = false;
                    submitButton.innerHTML = originalButtonContent;
                    unlockPaywalledPage();
                    return;
                }
                // Store auth token
                (0, $2d55885df2a8a6bb$export$894225851aaae84a)(currentContentId);
                // Get redirect URL
                const redirectUrl = (0, $2d55885df2a8a6bb$export$93832c3affb240d3)(currentContentId);
                if (redirectUrl) // Redirect to protected page
                window.location.href = redirectUrl;
                else {
                    showError('Redirect URL not found');
                    submitButton.disabled = false;
                    submitButton.innerHTML = originalButtonContent;
                }
            } else {
                // Show error
                showError('Password incorrect');
                submitButton.disabled = false;
                submitButton.innerHTML = originalButtonContent;
                passwordInput.value = '';
                passwordInput.focus();
            }
        } catch (error) {
            console.error('Error validating password:', error);
            showError('An error occurred. Please try again.');
            submitButton.disabled = false;
            submitButton.innerHTML = originalButtonContent;
        }
    }
    // Adiciona evento de clique para todos os botões que abrem a password modal
    $00c5cb1594812d6b$var$openPasswordModal.forEach((button)=>{
        button.addEventListener("click", ()=>{
            // Get content ID from data attribute
            currentContentId = button.dataset.contentId;
            // Check if user is already authenticated for this content
            if ((0, $2d55885df2a8a6bb$export$83d11f23a23d4a7c)(currentContentId)) {
                // User is already authenticated, navigate directly to the protected page
                const redirectUrl = (0, $2d55885df2a8a6bb$export$93832c3affb240d3)(currentContentId);
                if (redirectUrl) window.location.href = redirectUrl;
            } else // User is not authenticated, open password dialog
            openPasswordDialog();
        });
    });
    // Submit on button click
    if (submitButton) submitButton.addEventListener('click', handlePasswordSubmit);
    // Submit on Enter key
    if (passwordInput) passwordInput.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handlePasswordSubmit();
        }
    });
    // Adiciona evento de clique para o botão que fecha a password modal
    if ($00c5cb1594812d6b$var$closePasswordModal) $00c5cb1594812d6b$var$closePasswordModal.addEventListener("click", closePasswordDialog);
    // Evento para fechar a password dialog com a tecla ESC
    // Evento para fechar a password dialog com a tecla ESC
    $00c5cb1594812d6b$var$passwordModal.addEventListener('cancel', (event)=>{
        event.preventDefault();
        closePasswordDialog();
    });
    // Detecta quando o usuário clica em 'voltar' ou 'avançar' no navegador
    window.addEventListener('popstate', (event)=>{
        // Paywall dialog has no history entry of its own; ignore history navigation
        if (isPaywallDialog()) return;
        if (event.state && event.state.page === 'password-protected') {
            const stateContentId = event.state.contentId || currentContentId;
            if (stateContentId && (0, $2d55885df2a8a6bb$export$83d11f23a23d4a7c)(stateContentId)) // User is already authenticated, don't reopen dialog. Clean up URL.
            history.replaceState(null, '', window.location.pathname + window.location.search);
            else {
                if (stateContentId) currentContentId = stateContentId;
                openPasswordDialog();
            }
        } else if ($00c5cb1594812d6b$var$passwordModal.hasAttribute('open')) closePasswordDialog();
    });
    // Handle BFCache (Back-Forward Cache) restores
    window.addEventListener('pageshow', (event)=>{
        // Paywall page restored from BFCache (e.g. browser "forward") after fading out:
        // make the dialog visible again
        if (event.persisted && isPaywallDialog()) $00c5cb1594812d6b$var$passwordModal.classList.remove('fade-out');
        if (event.persisted && currentContentId && (0, $2d55885df2a8a6bb$export$83d11f23a23d4a7c)(currentContentId)) {
            if ($00c5cb1594812d6b$var$passwordModal.hasAttribute('open')) {
                $00c5cb1594812d6b$var$passwordModal.close();
                $00c5cb1594812d6b$var$body.classList.remove('body-fixed');
                history.replaceState(null, '', window.location.pathname + window.location.search);
            }
            if (submitButton && submitButton.disabled) {
                submitButton.disabled = false;
                submitButton.innerHTML = originalButtonContent;
            }
        }
    });
    // Paywall: on a protected case page, show the dialog immediately if the visitor has no access.
    // (checkRecruiterToken() above already processed any ?ref= token.)
    if ($00c5cb1594812d6b$var$protectedContentId) {
        if ((0, $2d55885df2a8a6bb$export$83d11f23a23d4a7c)($00c5cb1594812d6b$var$protectedContentId)) document.documentElement.classList.remove('is-locked');
        else {
            currentContentId = $00c5cb1594812d6b$var$protectedContentId;
            openPasswordDialog();
        }
    }
    // Verifica se a URL contém o hash '#password-protected' quando a página é carregada
    // Also check for content ID in query params
    document.addEventListener('DOMContentLoaded', (event)=>{
        if (window.location.hash.includes('#password-protected')) {
            // Extract content ID from query params if present
            const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
            const contentId = urlParams.get('content');
            if (contentId) currentContentId = contentId;
            if (currentContentId && (0, $2d55885df2a8a6bb$export$83d11f23a23d4a7c)(currentContentId)) // User is authenticated, clean up URL and don't open dialog
            history.replaceState(null, '', window.location.pathname + window.location.search);
            else // Skip animation when opening from redirect to prevent flash
            openPasswordDialog(true);
        }
    });
    // Password visibility toggle functionality (industry-standard approach)
    const togglePasswordButton = $00c5cb1594812d6b$var$passwordModal?.querySelector('.btn-toggle-password');
    if (togglePasswordButton && passwordInput) {
        let isPasswordVisible = false;
        // Function to toggle password visibility
        const toggleVisibility = (e)=>{
            // Prevent default behavior to maintain focus
            e.preventDefault();
            // Store cursor position
            const cursorPosition = passwordInput.selectionStart;
            // Toggle state
            isPasswordVisible = !isPasswordVisible;
            // Change input type
            passwordInput.type = isPasswordVisible ? 'text' : 'password';
            // Toggle visual checkbox state and ARIA attributes
            if (isPasswordVisible) {
                togglePasswordButton.classList.add('checked');
                togglePasswordButton.setAttribute('aria-checked', 'true');
            } else {
                togglePasswordButton.classList.remove('checked');
                togglePasswordButton.setAttribute('aria-checked', 'false');
            }
            // Restore focus and cursor position
            passwordInput.focus();
            passwordInput.setSelectionRange(cursorPosition, cursorPosition);
        };
        // pointerdown + preventDefault() prevents focus transfer on Chrome/Safari.
        // Firefox and Firefox Focus ignore this for focus management, so we also
        // add a blur guard: if the input blurs while the toggle is being pressed,
        // restore focus synchronously before the keyboard has a chance to close.
        let isToggling = false;
        togglePasswordButton.addEventListener('pointerdown', (e)=>{
            isToggling = true;
            toggleVisibility(e);
            // Reset flag after a short tick in case blur doesn't fire (e.g. desktop)
            setTimeout(()=>{
                isToggling = false;
            }, 100);
        });
        passwordInput.addEventListener('blur', ()=>{
            if (isToggling) {
                isToggling = false;
                passwordInput.focus(); // Restore focus before keyboard dismisses
            }
        });
        // Add keyboard support for accessibility (Space and Enter keys)
        togglePasswordButton.addEventListener('keydown', (e)=>{
            // Only respond to Space or Enter keys
            if (e.key === ' ' || e.key === 'Enter') toggleVisibility(e);
        });
    }
}
/////////////////////////////////////////////////////////////////
///Função para copiar email para a clipboard
/////////////////////////////////////////////////////////////////
async function $00c5cb1594812d6b$var$copyToClipboard() {
    const emailSpan = document.querySelector(".email-to-copy");
    const emailText = emailSpan.innerText;
    try {
        await navigator.clipboard.writeText(emailText);
        const successMessage = document.querySelector(".success-message");
        successMessage.style.display = "block";
    } catch (error) {
        console.error("Erro ao copiar para a \xe1rea de transfer\xeancia:", error);
        const errorMessage = document.querySelector(".error-message");
        errorMessage.style.display = "block";
    }
}
// Attach event listener to copy button
const $00c5cb1594812d6b$var$copyButton = document.querySelector('.btn-copy-email');
if ($00c5cb1594812d6b$var$copyButton) $00c5cb1594812d6b$var$copyButton.addEventListener('click', $00c5cb1594812d6b$var$copyToClipboard);
/////////////////////////////////////////////////////////////////
/// Função para controlar a navbar
/////////////////////////////////////////////////////////////////
const $00c5cb1594812d6b$var$primaryNav = document.querySelector(".main-nav-list");
const $00c5cb1594812d6b$var$navToggle = document.querySelector(".mobile-nav-toggle");
if ($00c5cb1594812d6b$var$primaryNav && $00c5cb1594812d6b$var$navToggle) {
    const focusableElements = $00c5cb1594812d6b$var$primaryNav.querySelectorAll('.main-nav-a');
    // Function to update tabindex based on screen size and menu state
    const updateTabIndex = ()=>{
        const isMobile = window.getComputedStyle($00c5cb1594812d6b$var$navToggle).display !== 'none';
        const isVisible = $00c5cb1594812d6b$var$primaryNav.getAttribute("data-visible") === "true";
        focusableElements.forEach((el)=>{
            if (isMobile) // On mobile, only focusable if menu is open
            el.setAttribute('tabindex', isVisible ? '0' : '-1');
            else // On desktop, always focusable
            el.removeAttribute('tabindex');
        });
        // Reset data-visible attribute when switching to desktop to prevent weird states
        if (!isMobile && isVisible) {
            $00c5cb1594812d6b$var$primaryNav.setAttribute("data-visible", "false");
            $00c5cb1594812d6b$var$navToggle.setAttribute('aria-expanded', "false");
            $00c5cb1594812d6b$var$navbar.classList.remove('open');
            $00c5cb1594812d6b$var$navbar.classList.add('closed');
            $00c5cb1594812d6b$var$body.style.overflow = 'auto';
        }
    };
    // Helper to close the nav without touching history (used by both the toggle and the popstate handler)
    function closeNav() {
        $00c5cb1594812d6b$var$primaryNav.setAttribute("data-visible", false);
        $00c5cb1594812d6b$var$navToggle.setAttribute('aria-expanded', false);
        $00c5cb1594812d6b$var$navbar.classList.remove('open');
        $00c5cb1594812d6b$var$navbar.classList.add('closed');
        setTimeout(()=>{
            $00c5cb1594812d6b$var$body.style.overflow = 'auto';
        }, 450);
        focusableElements.forEach((el)=>el.setAttribute('tabindex', '-1'));
    }
    $00c5cb1594812d6b$var$navToggle.addEventListener("click", ()=>{
        const visibility = $00c5cb1594812d6b$var$primaryNav.getAttribute("data-visible");
        if (visibility === "false") {
            $00c5cb1594812d6b$var$primaryNav.setAttribute("data-visible", true);
            $00c5cb1594812d6b$var$navToggle.setAttribute('aria-expanded', true);
            $00c5cb1594812d6b$var$body.style.overflow = 'hidden';
            $00c5cb1594812d6b$var$navbar.classList.add('open');
            $00c5cb1594812d6b$var$navbar.classList.remove('closed');
            // Push a history entry so the device back button can close the menu
            history.pushState({
                menuOpen: true
            }, '', '#menu');
            // Enable focus on elements
            focusableElements.forEach((el)=>el.removeAttribute('tabindex'));
            // Focus on the first link
            focusableElements[0].focus();
        } else if (visibility === "true") {
            closeNav();
            // Remove the history entry that was pushed when the menu opened
            history.replaceState(null, '', window.location.pathname);
        }
    });
    // Close the menu when the user presses the device back button.
    // Guard: only act if the menu is actually open AND no dialog is currently open,
    // so this never conflicts with the email / password dialog popstate handlers.
    window.addEventListener('popstate', ()=>{
        const isMenuOpen = $00c5cb1594812d6b$var$primaryNav.getAttribute('data-visible') === 'true';
        const isAnyDialogOpen = $00c5cb1594812d6b$var$modal?.hasAttribute('open') || $00c5cb1594812d6b$var$passwordModal?.hasAttribute('open');
        if (isMenuOpen && !isAnyDialogOpen) closeNav();
    });
    // Handle keyboard navigation loop + Escape to close
    document.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape') {
            const visibility = $00c5cb1594812d6b$var$primaryNav.getAttribute("data-visible");
            const isMobile = window.getComputedStyle($00c5cb1594812d6b$var$navToggle).display !== 'none';
            const isAnyDialogOpen = $00c5cb1594812d6b$var$modal?.hasAttribute('open') || $00c5cb1594812d6b$var$passwordModal?.hasAttribute('open');
            // Only close the nav if no dialog is currently open.
            // The dialog's own `cancel` event already handles Escape for dialogs,
            // so this ensures only one layer is dismissed per key press.
            if (isMobile && visibility === "true" && !isAnyDialogOpen) {
                closeNav();
                history.replaceState(null, '', window.location.pathname);
                $00c5cb1594812d6b$var$navToggle.focus(); // Return focus to the hamburger button
            }
        }
        if (event.key === 'Tab') {
            const visibility = $00c5cb1594812d6b$var$primaryNav.getAttribute("data-visible");
            const isMobile = window.getComputedStyle($00c5cb1594812d6b$var$navToggle).display !== 'none';
            if (isMobile && visibility === "true") {
                const firstFocusableElement = $00c5cb1594812d6b$var$navToggle;
                const lastFocusableElement = focusableElements[focusableElements.length - 1];
                if (event.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        event.preventDefault();
                        lastFocusableElement.focus();
                    }
                } else if (document.activeElement === lastFocusableElement) {
                    event.preventDefault();
                    firstFocusableElement.focus();
                }
            }
        }
    });
    // Initial check and listen for resize
    updateTabIndex();
    window.addEventListener('resize', updateTabIndex);
}
/////////////////////////////////////////////////////////////////
/// Function to calculate Springer Nature Work duration
/////////////////////////////////////////////////////////////////
function $00c5cb1594812d6b$var$calculateWorkDuration(startDate) {
    const start = new Date(startDate);
    const now = new Date();
    let years = now.getFullYear() - start.getFullYear();
    let months = now.getMonth() - start.getMonth();
    if (months < 0) {
        years--;
        months += 12;
    }
    return `${years} yrs ${months} mos`;
}
// Example usage:
const $00c5cb1594812d6b$var$startDate = '2021-01-01'; // Use your own start date
const $00c5cb1594812d6b$var$workDurationElement = document.getElementById('workDuration');
if ($00c5cb1594812d6b$var$workDurationElement) $00c5cb1594812d6b$var$workDurationElement.innerText = $00c5cb1594812d6b$var$calculateWorkDuration($00c5cb1594812d6b$var$startDate);
/////////////////////////////////////////////////////////////////
/// Animate experience accordion details element
/////////////////////////////////////////////////////////////////
document.addEventListener('click', function(event) {
    let target = event.target;
    // Traverse up to find the closest summary or details element
    while(target != null && !target.matches('summary') && !target.matches('details'))target = target.parentElement;
    // Check if target is a summary child, find the summary in that case
    if (target && !target.matches('summary') && target.parentElement.matches('summary')) target = target.parentElement;
    // Proceed only if a summary element was clicked or a child of a summary
    if (target && target.matches('summary') && target.parentElement.matches('details')) {
        const detailsElement = target.parentElement;
        const contentElement = target.nextElementSibling; // Assuming this is the content to be animated
        // Chrome sometimes does not properly animate, ensure classes are managed
        if (contentElement.classList.contains('animation')) {
            contentElement.classList.remove('animation', 'collapsing');
            // Force reflow
            contentElement.offsetWidth;
        }
        const onAnimationEnd = (callback)=>{
            contentElement.addEventListener('animationend', (e)=>{
                // Only respond to the grid-expand animation, ignore other animations
                if (e.animationName === 'grid-expand') callback(e);
            }, {
                once: true
            });
        };
        // Add animation class to start animation
        requestAnimationFrame(()=>{
            contentElement.classList.add('animation');
        });
        onAnimationEnd(()=>{
            contentElement.classList.remove('animation');
        });
        const isDetailsOpen = detailsElement.hasAttribute('open');
        if (isDetailsOpen) {
            // Prevent default collapsing and delay it until the animation has completed
            event.preventDefault();
            contentElement.classList.add('collapsing');
            onAnimationEnd(()=>{
                detailsElement.removeAttribute('open');
                contentElement.classList.remove('collapsing');
            });
        }
    }
});
/////////////////////////////////////////////////////////////////
/// Animation for the navbar scrolling
/////////////////////////////////////////////////////////////////
const $00c5cb1594812d6b$var$navbar = document.querySelector('.navbar');
const $00c5cb1594812d6b$var$mainNavList = document.querySelector('#main-nav-list');
let $00c5cb1594812d6b$var$lastScrollY = window.scrollY;
let $00c5cb1594812d6b$var$isListeningToScroll = true;
let $00c5cb1594812d6b$var$ticking = false;
// Minimum scroll distance in one direction before the navbar reacts.
const $00c5cb1594812d6b$var$SCROLL_THRESHOLD = 8;
let $00c5cb1594812d6b$var$scrollDelta = 0;
// Tracks the hide animation timeout so it can be cancelled on direction change.
let $00c5cb1594812d6b$var$hideTimeout = null;
// Function to update navbar position
const $00c5cb1594812d6b$var$updateNavbar = ()=>{
    if (!$00c5cb1594812d6b$var$navbar) return;
    const currentScrollY = window.scrollY;
    const diff = currentScrollY - $00c5cb1594812d6b$var$lastScrollY;
    const isScrolledUp = $00c5cb1594812d6b$var$navbar.classList.contains('scrolled-up');
    const isHiding = $00c5cb1594812d6b$var$navbar.classList.contains('hiding');
    if (currentScrollY <= 0) {
        // Back at the very top: reset to natural state (position: relative)
        $00c5cb1594812d6b$var$scrollDelta = 0;
        if ($00c5cb1594812d6b$var$hideTimeout) {
            clearTimeout($00c5cb1594812d6b$var$hideTimeout);
            $00c5cb1594812d6b$var$hideTimeout = null;
        }
        $00c5cb1594812d6b$var$navbar.classList.remove('scrolled-up', 'hiding');
    } else if (diff > 0) {
        // Scrolling down — accumulate delta and reset if direction just changed
        $00c5cb1594812d6b$var$scrollDelta = Math.max(0, $00c5cb1594812d6b$var$scrollDelta) + diff;
        if (isScrolledUp && !isHiding && $00c5cb1594812d6b$var$scrollDelta > $00c5cb1594812d6b$var$SCROLL_THRESHOLD) {
            // Navbar is sticky-visible at top; animate it out before releasing it
            $00c5cb1594812d6b$var$scrollDelta = 0;
            $00c5cb1594812d6b$var$navbar.classList.add('hiding');
            $00c5cb1594812d6b$var$hideTimeout = setTimeout(()=>{
                $00c5cb1594812d6b$var$navbar.classList.remove('hiding', 'scrolled-up');
                $00c5cb1594812d6b$var$hideTimeout = null;
            }, 250); // matches navbar-slide-out duration
        }
    } else if (diff < 0) {
        // Scrolling up — accumulate delta and reset if direction just changed
        $00c5cb1594812d6b$var$scrollDelta = Math.min(0, $00c5cb1594812d6b$var$scrollDelta) + diff;
        // Only snap the navbar to top when we're far enough down the page that
        // the navbar is naturally out of view (> its own height from the top).
        if (!isScrolledUp && currentScrollY > $00c5cb1594812d6b$var$navbar.offsetHeight && $00c5cb1594812d6b$var$scrollDelta < -$00c5cb1594812d6b$var$SCROLL_THRESHOLD) {
            $00c5cb1594812d6b$var$scrollDelta = 0;
            // Cancel any pending hide if the user reverses direction quickly
            if ($00c5cb1594812d6b$var$hideTimeout) {
                clearTimeout($00c5cb1594812d6b$var$hideTimeout);
                $00c5cb1594812d6b$var$hideTimeout = null;
            }
            $00c5cb1594812d6b$var$navbar.classList.remove('hiding');
            $00c5cb1594812d6b$var$navbar.classList.add('scrolled-up');
        }
    }
    $00c5cb1594812d6b$var$lastScrollY = currentScrollY;
    $00c5cb1594812d6b$var$ticking = false;
};
// Function to handle scroll events
const $00c5cb1594812d6b$var$onScroll = ()=>{
    if (!$00c5cb1594812d6b$var$isListeningToScroll) return;
    if (!$00c5cb1594812d6b$var$ticking) {
        window.requestAnimationFrame($00c5cb1594812d6b$var$updateNavbar);
        $00c5cb1594812d6b$var$ticking = true;
    }
};
// Add scroll event listener
window.addEventListener('scroll', $00c5cb1594812d6b$var$onScroll);
// Create a mutation observer to monitor changes in attributes
const $00c5cb1594812d6b$var$observer = new MutationObserver((mutationsList)=>{
    for (let mutation of mutationsList)if (mutation.type === 'attributes' && mutation.attributeName === 'data-visible') {
        const visibility = $00c5cb1594812d6b$var$mainNavList.getAttribute('data-visible');
        if (visibility === "true") $00c5cb1594812d6b$var$isListeningToScroll = false;
        else if (visibility === "false") $00c5cb1594812d6b$var$isListeningToScroll = true;
    }
});
// Start observing the target node for configured mutations
if ($00c5cb1594812d6b$var$mainNavList) $00c5cb1594812d6b$var$observer.observe($00c5cb1594812d6b$var$mainNavList, {
    attributes: true
});
/////////////////////////////////////////////////////////////////
///// Initialize medium-zoom library
/////////////////////////////////////////////////////////////////
(0, $4ffa2ba0c2b40bcc$export$2e2bcd8739ae039)('.medium-zoom-image', {
    margin: 0,
    background: 'rgba(0, 0, 0, 0.85)',
    scrollOffset: 0,
    container: null,
    template: null
});


//# sourceMappingURL=about.59e5d915.js.map
